<template>
  <div class="celan">
    <!-- 侧栏 -->
    <el-aside width="200px" style="background: #e6e6e6;">
      <el-menu :default-openeds="['', '']" style="background: #e6e6e6;">
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-tickets"></i>订单总览</template>
            <el-menu-item-group>
              <el-menu-item index="1-1">
                <router-link to='/'>订单总览</router-link>
              </el-menu-item>              
              <el-menu-item index="1-2">
                <router-link to='/successpay'>订单列表</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-message"></i> 收 款 码</template>
            <el-menu-item-group>
              <el-menu-item index="2-1">
                <router-link to='/upimg'>上传收款码</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to='/imglist'>收款码列表</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>      
          <el-submenu index="3">
            <template slot="title"><i class="el-icon-info"></i>使用说明</template>
            <el-menu-item-group>
              <el-menu-item index="3-1">
                <router-link to='/faqipay'>发起支付</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
      </el-menu>
    </el-aside>  
  </div>
</template>

<script>

export default {
  name: 'celan',
  data(){
     return{

     }
  },
  mounted(){

  },
  methods: {

  }
}

</script>


<style scoped>
.celan {
    background: #e6e6e6;
}

</style>



// WEBPACK FOOTER //
// src/components/celan.vue